import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import moment from 'moment';
import { TableModule } from 'primeng/table';
import {
  TrainPerformanceClassificationColor,
  TrainPerformanceTextColor
} from 'src/app/models/train-info.model';

@Component({
  selector: 'csx-ioh-equipment-info-table',
  templateUrl: './ioh-equipment-info-table.component.html',
  styleUrl: './ioh-equipment-info-table.component.scss',
  imports: [CommonModule, TableModule]
})
export class IohEquipmentInfoTableComponent implements OnInit {
  utc = moment.utc;
  @Input() columns = [];
  @Input() dataTable = [];
  @Input() scrollable = false;
  @Input() chassisInventoryTable = false;
  @Input() hasHeader = false;
  @Input() rowClickable = false;
  @Output() rowClick = new EventEmitter<any>();

  ngOnInit() {}

  handleRowClick(rowData: any): void {
    if (this.rowClickable) {
      this.rowClick.emit(rowData);
    }
  }

  hasStatus(status: string): boolean {
    return !!(status && status.trim());
  }

  isEtaHeader(header: string): boolean {
    return (header || '').toUpperCase().includes('ETA');
  }

  getEtaHeaderPrefix(header: string): string {
    return (header || '').replace(/ETA/i, '').trim();
  }

  shouldItalicizeAdjustedTime(header: string, status: string): boolean {
    return this.isEtaHeader(header) && (status || '').trim().toLowerCase() === 'enroute';
  }

  getPerformanceColor(performance) {
    let bgColor = '';
    let textColor = '';
    if (performance == 'Early') {
      bgColor =
        TrainPerformanceClassificationColor.PERFORMANCE_CLASSIFICATION_EARLY;
      textColor = TrainPerformanceTextColor.PERFORMANCE_CLASSIFICATION_EARLY;
    } else if (performance == 'AOT') {
      bgColor =
        TrainPerformanceClassificationColor.PERFORMANCE_CLASSIFICATION_AHEAD_OF_TIME;
      textColor =
        TrainPerformanceTextColor.PERFORMANCE_CLASSIFICATION_AHEAD_OF_TIME;
    } else if (performance == 'Delayed') {
      bgColor =
        TrainPerformanceClassificationColor.PERFORMANCE_CLASSIFICATION_DELAYED;
      textColor = TrainPerformanceTextColor.PERFORMANCE_CLASSIFICATION_DELAYED;
    } else {
      bgColor =
        TrainPerformanceClassificationColor.PERFORMANCE_CLASSIFICATION_LATE;
      textColor = TrainPerformanceTextColor.Late;
    }

    return { background: bgColor, color: textColor };
  }

  getTrainStatusConfig(status: string) {
    const normalizedStatus = (status || '').trim().toLowerCase();

    if (normalizedStatus === 'enroute') {
      return {
        iconClass: 'csxi csxi-car-train',
        style: { background: 'rgba(59,130,246,0.18)', color: '#60A5FA' }
      };
    }

    if (normalizedStatus === 'arrived') {
      return {
        iconClass: 'pi pi-map-marker',
        style: { background: 'rgba(34,197,94,0.18)', color: '#4ADE80' }
      };
    }

    if (normalizedStatus === 'atterminal') {
      return {
        iconClass: 'csxi csxi-yard',
        style: { background: 'rgba(245,158,11,0.18)', color: '#FBBF24' }
      };
    }

    return {
      iconClass: '',
      style: { background: 'rgba(255,255,255,0.08)', color: '#FFFFFF' }
    };
  }

  timeToTotalMinutes(timeStr, type) {
    const [hours, minutes] = timeStr.split(':').map(Number);
    const count = `${hours}h ${minutes}m`;

    return type == 'Late' || type == 'Delayed' ? `${count}L` : `${count}`;
  }
}
